import { SelectField } from '@/ui'

const TIMEZONES = Intl.supportedValuesOf('timeZone')

interface Props {
	value: string
	onChange: (timezone: string) => void
}

export function TimezoneSelector({ value, onChange }: Props) {
	return (
		<SelectField
			options={TIMEZONES}
			value={value}
			onChange={onChange}
			hideLabel={true}
			sizing="small"
		/>
	)
}
